// TSS vite/06 — env-driven config.
//
// La baseURL de la API es RELATIVA por defecto (`/api/v1` = mismo origen). En
// producción el front y el backend comparten origen vía el proxy (Apache), así la
// cookie de sesión queda first-party. En dev, el proxy de Vite (vite.config.js)
// reenvía `/api` al backend. NUNCA una URL absoluta hardcodeada en el bundle:
// `VITE_API_ENDPOINT` puede sobreescribir el default, pero en producción debe ser
// una ruta relativa (`/api/v1`), no `https://...` (rompería las cookies first-party).

export const api = {
    endpoint: import.meta.env.VITE_API_ENDPOINT || '/api/v1',
};

export const meta = {
    projectName: import.meta.env.VITE_PROJECT_NAME || 'Trianametria App',
};
